module.exports = __webpack_public_path__ + "static/media/a.48b70525.mp3";